// Дзеркало Prisma enum AuditAction. Дії журналу аудиту (D28).
// Значення ідентичні apps/api/prisma/schema.prisma (перевіряє test/enums.spec.ts). Підписи — лише тут.
export const AuditAction = {
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    STATUS_CHANGE: 'STATUS_CHANGE',
    IMPORT: 'IMPORT',
    EXPORT: 'EXPORT',
    GENERATE: 'GENERATE',
    APPROVE: 'APPROVE',
    RETURN: 'RETURN',
    PUBLISH: 'PUBLISH',
    LOGIN: 'LOGIN',
};
/** Значення в порядку оголошення в схемі. */
export const AUDIT_ACTION_VALUES = ['CREATE', 'UPDATE', 'DELETE', 'STATUS_CHANGE', 'IMPORT', 'EXPORT', 'GENERATE', 'APPROVE', 'RETURN', 'PUBLISH', 'LOGIN'];
export const AUDIT_ACTION_LABELS = {
    CREATE: 'Створення',
    UPDATE: 'Зміна',
    DELETE: 'Видалення',
    STATUS_CHANGE: 'Зміна статусу',
    IMPORT: 'Імпорт',
    EXPORT: 'Експорт',
    GENERATE: 'Генерація',
    APPROVE: 'Погодження',
    RETURN: 'Повернення на доопрацювання',
    PUBLISH: 'Публікація',
    LOGIN: 'Вхід',
};
//# sourceMappingURL=audit-action.js.map